import smartSolveApi from './instances/smartsolve';

export const getAnswer = async (question) => {
  try {
    const { data } = await smartSolveApi.post('/chatbot', {
      Question: question,
    });
    return data;
  } catch (e) {
    throw new Error(`getAnswer() failed: ${e}`);
  }
};
